import classNames from "classnames";
import React, { useContext } from "react";

import { ThemeContext } from "../../contexts/ThemeContext";
import { getSeasonCardVariantTitle } from "../../ecommerce/common";
import { ExtendedCartMerchandise } from "../../types/shopify-components";
import Money from "../Money";
import Radio from "../Radio";

export const TEST_ID_COMPARE_AT_PRICE =
  "season-pass-product-variant-compare-at-price";
export const TEST_ID_PRICE = "season-pass-product-variant-price";

interface SeasonPassProductVariantProps {
  isSelected: boolean;
  selectVariant: React.ChangeEventHandler<HTMLInputElement>;
  merchandise: ExtendedCartMerchandise;
}

const SeasonPassProductVariant: React.FC<SeasonPassProductVariantProps> = ({
  isSelected,
  selectVariant,
  merchandise,
}) => {
  const { styles } = useContext(ThemeContext);
  const { compareAtPrice, id, price, selectedOptions } = merchandise;

  return (
    <label className={classNames("flex items-center mb3", styles.paragraph1)}>
      <div className="flex justify-between w-100">
        <Radio
          checked={isSelected}
          onChange={selectVariant}
          label={getSeasonCardVariantTitle(selectedOptions) ?? ""}
          value={id}
          name="selected-variant"
        />
        <div className="flex b">
          {compareAtPrice &&
            Number(compareAtPrice.amount) > Number(price.amount) && (
              <div
                className="mr2 dark-gray strike"
                data-testid={TEST_ID_COMPARE_AT_PRICE}
              >
                <Money value={compareAtPrice.amount} />
              </div>
            )}
          <div data-testid={TEST_ID_PRICE}>
            <Money value={price.amount} />
          </div>
        </div>
      </div>
    </label>
  );
};

export default SeasonPassProductVariant;
